/**
 * Side nav with navigation to different account settings.
 */
import React, { useEffect, useLayoutEffect, useRef } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import css from './LayoutSideNavigation.module.css';

const NavIconContact = ({ className }) => (
  <svg
    className={className}
    width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.3125 1.75C0.587891 1.75 0 2.33789 0 3.0625C0 3.47539 0.194141 3.86367 0.525 4.1125L6.475 8.575C6.78672 8.80742 7.21328 8.80742 7.525 8.575L13.475 4.1125C13.8059 3.86367 14 3.47539 14 3.0625C14 2.33789 13.4121 1.75 12.6875 1.75H1.3125ZM0 4.8125V10.5C0 11.4652 0.784766 12.25 1.75 12.25H12.25C13.2152 12.25 14 11.4652 14 10.5V4.8125L8.05 9.275C7.42656 9.74258 6.57344 9.74258 5.95 9.275L0 4.8125Z" fill="#52525B" />
  </svg>

);

const NavIconShipping = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10 10.833a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 1.667c-2.761 0-5 2.239-5 5 0 3.75 5 11.666 5 11.666s5-7.916 5-11.666c0-2.761-2.239-5-5-5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const NavIconPassword = ({ className }) => (
  <svg
    className={className}
   width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.9375 3.9375V5.25H8.3125V3.9375C8.3125 2.72891 7.33359 1.75 6.125 1.75C4.91641 1.75 3.9375 2.72891 3.9375 3.9375ZM2.1875 5.25V3.9375C2.1875 1.76367 3.95117 0 6.125 0C8.29883 0 10.0625 1.76367 10.0625 3.9375V5.25H10.5C11.4652 5.25 12.25 6.03477 12.25 7V12.25C12.25 13.2152 11.4652 14 10.5 14H1.75C0.784766 14 0 13.2152 0 12.25V7C0 6.03477 0.784766 5.25 1.75 5.25H2.1875Z" fill="#52525B"/>
    </svg>
    
);

const NavIconPayout = ({ className }) => (
  <svg
    className={className}
    width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.65749 0.0716797L0.532495 2.69668C0.149682 2.86074 -0.0635992 3.2709 0.0211665 3.67559C0.105932 4.08027 0.461401 4.37559 0.877026 4.37559V4.59434C0.877026 4.95801 1.1696 5.25059 1.53328 5.25059H12.4708C12.8344 5.25059 13.127 4.95801 13.127 4.59434V4.37559C13.5427 4.37559 13.9009 4.08301 13.9829 3.67559C14.0649 3.26816 13.8516 2.85801 13.4716 2.69668L7.34656 0.0716797C7.12781 -0.0212891 6.87624 -0.0212891 6.65749 0.0716797ZM3.50203 6.12559H1.75203V11.4932C1.73562 11.5014 1.71921 11.5123 1.70281 11.5232L0.390307 12.3982C0.0703852 12.6115 -0.0745367 13.0107 0.0375727 13.3799C0.149682 13.749 0.491479 14.0006 0.877026 14.0006H13.127C13.5126 14.0006 13.8516 13.749 13.9637 13.3799C14.0759 13.0107 13.9337 12.6115 13.611 12.3982L12.2985 11.5232C12.2821 11.5123 12.2657 11.5041 12.2493 11.4932V6.12559H10.502V11.3756H9.40828V6.12559H7.65828V11.3756H6.34578V6.12559H4.59578V11.3756H3.50203V6.12559ZM7.00203 1.75059C7.23409 1.75059 7.45665 1.84277 7.62074 2.00687C7.78484 2.17096 7.87703 2.39352 7.87703 2.62559C7.87703 2.85765 7.78484 3.08021 7.62074 3.2443C7.45665 3.4084 7.23409 3.50059 7.00203 3.50059C6.76996 3.50059 6.5474 3.4084 6.38331 3.2443C6.21921 3.08021 6.12703 2.85765 6.12703 2.62559C6.12703 2.39352 6.21921 2.17096 6.38331 2.00687C6.5474 1.84277 6.76996 1.75059 7.00203 1.75059Z" fill="#52525B"/>
    </svg>
    
);

const NavIconPayment = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M2.5 7.5h15c.92 0 1.667.746 1.667 1.667v5.833c0 .92-.746 1.667-1.667 1.667h-15c-.92 0-1.667-.746-1.667-1.667V9.167c0-.92.746-1.667 1.667-1.667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 9.167h15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const NavIconManageAccount = ({ className }) => (
  <svg
    className={className}
     width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5592 4.55547C13.6467 4.79336 13.5729 5.05859 13.3842 5.22813L12.2003 6.30547C12.2303 6.53242 12.2467 6.76484 12.2467 7C12.2467 7.23516 12.2303 7.46758 12.2003 7.69453L13.3842 8.77187C13.5729 8.94141 13.6467 9.20664 13.5592 9.44453C13.4389 9.76992 13.294 10.0816 13.1272 10.3824L12.9987 10.6039C12.8182 10.9047 12.6159 11.1891 12.3944 11.457C12.2331 11.6539 11.9651 11.7195 11.7245 11.643L10.2014 11.159C9.83502 11.4406 9.43033 11.6758 8.9983 11.8535L8.6565 13.4148C8.60181 13.6637 8.41041 13.8605 8.15884 13.9016C7.7815 13.9645 7.39322 13.9973 6.99674 13.9973C6.60025 13.9973 6.21197 13.9645 5.83463 13.9016C5.58306 13.8605 5.39166 13.6637 5.33697 13.4148L4.99517 11.8535C4.56314 11.6758 4.15845 11.4406 3.79205 11.159L2.27174 11.6457C2.03111 11.7223 1.76314 11.6539 1.60181 11.4598C1.38033 11.1918 1.17799 10.9074 0.997517 10.6066L0.869001 10.3852C0.702204 10.0844 0.557282 9.77266 0.43697 9.44727C0.34947 9.20938 0.423298 8.94414 0.61197 8.77461L1.79595 7.69727C1.76588 7.46758 1.74947 7.23516 1.74947 7C1.74947 6.76484 1.76588 6.53242 1.79595 6.30547L0.61197 5.22813C0.423298 5.05859 0.34947 4.79336 0.43697 4.55547C0.557282 4.23008 0.702204 3.91836 0.869001 3.61758L0.997517 3.39609C1.17799 3.09531 1.38033 2.81094 1.60181 2.54297C1.76314 2.34609 2.03111 2.28047 2.27174 2.35703L3.79478 2.84102C4.16119 2.55938 4.56588 2.32422 4.99791 2.14648L5.3397 0.585156C5.39439 0.336328 5.5858 0.139453 5.83736 0.0984375C6.2147 0.0328125 6.60299 0 6.99947 0C7.39595 0 7.78424 0.0328125 8.16158 0.0957031C8.41314 0.136719 8.60455 0.333594 8.65924 0.582422L9.00103 2.14375C9.43306 2.32148 9.83775 2.55664 10.2042 2.83828L11.7272 2.3543C11.9678 2.27773 12.2358 2.34609 12.3971 2.54023C12.6186 2.8082 12.821 3.09258 13.0014 3.39336L13.1299 3.61484C13.2967 3.91562 13.4417 4.22734 13.562 4.55273L13.5592 4.55547ZM6.99947 9.1875C7.57963 9.1875 8.13603 8.95703 8.54627 8.5468C8.9565 8.13656 9.18697 7.58016 9.18697 7C9.18697 6.41984 8.9565 5.86344 8.54627 5.4532C8.13603 5.04297 7.57963 4.8125 6.99947 4.8125C6.41931 4.8125 5.86291 5.04297 5.45267 5.4532C5.04244 5.86344 4.81197 6.41984 4.81197 7C4.81197 7.58016 5.04244 8.13656 5.45267 8.5468C5.86291 8.95703 6.41931 9.1875 6.99947 9.1875Z" fill="#52525B"/>
    </svg>
    
);

const AccountSettingsNavItem = props => {
  const { id, selected, linkProps, icon: Icon, label } = props;
  const itemClasses = classNames(css.accountSettingsNavItem, {
    [css.accountSettingsNavItemSelected]: selected,
  });

  return (
    <NamedLink
      id={id}
      className={itemClasses}
      {...linkProps}
      data-account-settings-nav-item="true"
      data-nav-id={id}
      data-selected={selected ? 'true' : 'false'}
      onClick={() => {
        // Persist last clicked item so we can re-center after route change.
        // (On mobile, the scroll container often resets to left during navigation.)
        try {
          if (typeof window !== 'undefined') {
            window.sessionStorage?.setItem('accountSettingsNav:lastClickedId', id);
          }
        } catch (e) {
          // ignore
        }
      }}
    >
      <Icon className={css.accountSettingsNavIcon} />
      <span className={css.accountSettingsNavLabel}>{label}</span>
    </NamedLink>
  );
};

/**
 * @component
 * @param {Object} props
 * @param {Object} props.accountSettingsNavProps
 * @param {string?} props.accountSettingsNavProps.currentPage
 * @param {boolean?} props.accountSettingsNavProps.showPaymentMethods
 * @param {boolean?} props.accountSettingsNavProps.showPayoutDetails
 * @param {string} props.ariaLabel
 * @returns {JSX.Element}
 */
const LayoutWrapperAccountSettingsSideNav = props => {
  const { accountSettingsNavProps, ariaLabel } = props;
  const { currentPage, showPaymentMethods, showPayoutDetails } = accountSettingsNavProps;
  const navCardRef = useRef(null);

  const payoutDetailsMaybe = showPayoutDetails
    ? [
      {
        id: 'StripePayoutPageTab',
        selected: currentPage === 'StripePayoutPage',
        linkProps: { name: 'StripePayoutPage' },
        icon: NavIconPayout,
        label: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.paymentsTabTitle" />,
      },
    ]
    : [];

  const paymentMethodsMaybe = showPaymentMethods
    ? [
      {
        id: 'PaymentMethodsPageTab',
        selected: currentPage === 'PaymentMethodsPage',
        linkProps: { name: 'PaymentMethodsPage' },
        icon: NavIconPayment,
        label: (
          <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.paymentMethodsTabTitle" />
        ),
      },
    ]
    : [];

  const items = [
    {
      id: 'ContactDetailsPageTab',
      selected: currentPage === 'ContactDetailsPage',
      linkProps: { name: 'ContactDetailsPage' },
      icon: NavIconContact,
      label: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.contactDetailsTabTitle" />,
    },
    {
      id: 'ShippingAddressPageTab',
      selected: currentPage === 'ShippingAddressPage',
      linkProps: { name: 'ShippingAddressPage' },
      icon: NavIconShipping,
      label: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.shippingAddressTabTitle" />,
    },
    {
      id: 'PasswordChangePageTab',
      selected: currentPage === 'PasswordChangePage',
      linkProps: { name: 'PasswordChangePage' },
      icon: NavIconPassword,
      label: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.passwordTabTitle" />,
    },
    ...payoutDetailsMaybe,
    ...paymentMethodsMaybe,
    {
      id: 'ManageAccountPageTab',
      selected: currentPage === 'ManageAccountPage',
      linkProps: { name: 'ManageAccountPage' },
      icon: NavIconManageAccount,
      label: <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.manageAccountTabTitle" />,
    },
  ];

  const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

  useIsomorphicLayoutEffect(() => {
    if (typeof window === 'undefined') return;
    // Center the active item whenever this nav is horizontally scrollable.
    // Keep it scrollable so the user can still scroll manually afterwards.
    const centerSelected = (behavior = 'auto') => {
      const container = navCardRef.current;
      if (!container) return null;

      // Only do this when horizontal scrolling is actually possible.
      if (container.scrollWidth <= container.clientWidth + 1) return null;

      let lastClickedId = null;
      try {
        lastClickedId = window.sessionStorage?.getItem('accountSettingsNav:lastClickedId');
      } catch (e) {
        lastClickedId = null;
      }

      const selectedEl =
        (lastClickedId &&
          container.querySelector(
            `[data-account-settings-nav-item="true"][data-nav-id="${lastClickedId}"]`
          )) ||
        container.querySelector('[data-account-settings-nav-item="true"][data-selected="true"]');
      if (!selectedEl) return null;

      const targetLeft =
        selectedEl.offsetLeft - (container.clientWidth - selectedEl.offsetWidth) / 2;
      const nextLeft = Math.max(0, targetLeft);

      try {
        container.scrollTo({ left: nextLeft, behavior });
      } catch (e) {
        container.scrollLeft = nextLeft;
      }

      // Clear the stored click id once we've successfully applied centering.
      if (lastClickedId) {
        try {
          window.sessionStorage?.removeItem('accountSettingsNav:lastClickedId');
        } catch (e) {
          // ignore
        }
      }

      return nextLeft;
    };

    // Some pages/layouts reset scrollLeft after mount. We'll:
    // - run an immediate attempt
    // - run a short rAF loop (max attempts)
    // - observe size changes so we re-center when the scroller becomes scrollable
    let rafId = null;
    let attempts = 0;
    const maxAttempts = 30; // ~0.5s at 60fps

    const tick = () => {
      attempts += 1;
      centerSelected('auto');
      if (attempts < maxAttempts) {
        rafId = window.requestAnimationFrame(tick);
      }
    };

    centerSelected('auto');
    rafId = window.requestAnimationFrame(tick);

    let ro = null;
    try {
      ro = new window.ResizeObserver(() => {
        centerSelected('auto');
      });
      if (navCardRef.current) ro.observe(navCardRef.current);
    } catch (e) {
      // ignore if ResizeObserver is unavailable
    }

    const onWindowResize = () => centerSelected('auto');
    window.addEventListener('resize', onWindowResize, { passive: true });

    return () => {
      if (rafId) window.cancelAnimationFrame(rafId);
      window.removeEventListener('resize', onWindowResize);
      if (ro) ro.disconnect();
    };
  }, [currentPage, showPaymentMethods, showPayoutDetails]);

  return (
    <nav className={css.accountSettingsNav} aria-label={ariaLabel}>
      <div ref={navCardRef} className={css.accountSettingsNavCard}>
        {items.map(item => (
          <AccountSettingsNavItem key={item.id} {...item} />
        ))}
      </div>
    </nav>
  );
};

export default LayoutWrapperAccountSettingsSideNav;
